import { UITableViewCell, UILabel, UITextField, UIButton, UIControl, UIImageView, CAInputLayer } from "uikit";
import { CartLine, DLDB } from "dldb";



export interface BookingProductCellDelegate
{
    onNumProductDidChange ( cell: BookingProductCell, product:any, quantity:number ) : void ;
}

export class BookingProductCell extends UITableViewCell
{
    delegate: BookingProductCellDelegate = null;

    private imageView: UIImageView;
    private nameLabel: UILabel;
    private priceLabel: UILabel;
    private descriptionLabel: UILabel;
    private paxTextField: UITextField;
    private plusButton: UIButton;
    private minusButton: UIButton;

    private quantity: number = 0;

    awakeFromNib ( ) {      
        this.plusButton.addTarget( this, this.onPlus, UIControl.Event.touchUpInside );
        this.minusButton.addTarget( this, this.onMinus, UIControl.Event.touchUpInside );
    }
    
    private _product: any = null;
    set product ( product: any ) {
        this._product = product;
        this.quantity = 0;
        this.nameLabel.text = product["Name"] ;
        this.setImage( product["ImageURL"] );
        this.priceLabel.text = DLDB.shared.currencyFormatter().stringFromNumber( product["Price"] );
        this.descriptionLabel.text = product["DetailInfo"]?.length > 0 ? product["DetailInfo"] : product["Info"] ;
        this.paxTextField.text = this.quantity.toString();

        if (this._product["ID"] == "e2165d58-4444-4063-84c3-f5d5c5ccdcf6" || this._product["ID"] == "E2165D58-4444-4063-84C3-F5D5C5CCDCF6") {
            this.offset = 20;            
        }

    }

    private _line: CartLine = null;
    set line ( line: CartLine ) {
        this._line = line;
        this._product = { "Name": line.productName, "Price": line.productPrice, "ID": line.productID };
        this.quantity = DLDB.shared.cart().quantityByProductID( line.productID );
        this.setImage( null );
        this.nameLabel.text = line.productName
        this.priceLabel.text = DLDB.shared.currencyFormatter().stringFromNumber( line.productPrice );
        this.descriptionLabel.text = ""; //product["DetailInfo"]?.length > 0 ? product["DetailInfo"] : product["Info"] ;
        this.paxTextField.text = this.quantity.toString();
        if (this._product["ID"] == "e2165d58-4444-4063-84c3-f5d5c5ccdcf6" || this._product["ID"] == "E2165D58-4444-4063-84C3-F5D5C5CCDCF6") {
            this.offset = 20;            
        }
    }

    // Products without image show just the text: no placeholder box
    private setImage ( url: string | null ) {
        if ( this.imageView == null ) return;
        const has_image = url != null && url.length > 0;
        this.imageView.hidden = !has_image;
        if ( has_image ) this.imageView.imageURL = url;
    }

    private offset = 1;    

    private onPlus ( ) {
        const value = parseInt( this.paxTextField.text, 10 ) + this.offset;
        this.paxTextField.text = value.toString();
        this.quantity = value;
        this.delegate?.onNumProductDidChange( this, this._product, value );
    }

    private onMinus ( ) {
        const value = parseInt( this.paxTextField.text, 10 ) - this.offset;
        if ( value < 0 ) return ;
        this.quantity = value;
        this.paxTextField.text = value.toString();
        this.delegate?.onNumProductDidChange( this, this._product, value );
    }
}